export default {
  props: ['loading', "loading_time"],
  computed: {
    show() {
      return this.loading;
    }
  }
};